import {
    GET_ALL_STYLE_PENDING_REPORT_REQUEST, GET_ALL_STYLE_PENDING_REPORT_SUCESS, GET_ALL_STYLE_PENDING_REPORT_ERROR

} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";

///Post Bussiness dashboard
export const getStylePendingReport = (token, values) => (dispatch) => {
    dispatch({ type: GET_ALL_STYLE_PENDING_REPORT_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/getStyleWisePendingReport`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { ...values },
    })
        .then((response) => {
            return dispatch({
                type: GET_ALL_STYLE_PENDING_REPORT_SUCESS,
                payload: response.data,
            });
        })
        .catch((error) => {
            dispatch({
                type: GET_ALL_STYLE_PENDING_REPORT_ERROR,
                payload: [],
            });
        });
};
